export default __webpack_public_path__ + "static/internet3-de28c19ecdf4f3ed4b0fd3bd0df66b76.png";